/* Hotel PDP gallery — native scroll-snap gallery + filmstrip lightbox.
   The in-page main image and the lightbox are BOTH horizontal scroll-snap tracks, so
   swipe/drag follows the finger with native momentum + snap; arrows and thumbnails glide
   via scrollTo. Slide data (mb/dt/thumb urls + alt) comes from each .hgal's .hgal__data JSON.
   In-page + mobile lightbox use the mobile image; the desktop lightbox uses the desktop
   (on-zoom detail) asset. Paired with snippets/hotel-product-media-gallery.liquid +
   assets/hotel-product-media-gallery.css. */
(function () {
  var DESKTOP_MIN = 750; // Dawn's breakpoint
  function isDesktop() { return window.innerWidth >= DESKTOP_MIN; }
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // index of the slide whose centre is nearest the scroller's centre
  function centredIndex(scroller, slideSel) {
    var c = scroller.scrollLeft + scroller.clientWidth / 2, best = 0, bd = Infinity;
    scroller.querySelectorAll(slideSel).forEach(function (s, i) {
      var d = Math.abs(s.offsetLeft + s.clientWidth / 2 - c);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  }
  // scroll a slide to the horizontal centre of its scroller (instant when reduced-motion / smooth===false)
  function centreSlide(scroller, slide, smooth) {
    if (!scroller || !slide) return;
    scroller.scrollTo({
      left: slide.offsetLeft - (scroller.clientWidth - slide.clientWidth) / 2,
      behavior: (smooth === false || prefersReducedMotion) ? 'auto' : 'smooth'
    });
  }

  function initGallery(root) {
    var dataEl = root.querySelector('.hgal__data');
    if (!dataEl) return;
    var slides;
    try { slides = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!slides || !slides.length) return;

    var bestseller = root.getAttribute('data-bestseller') === 'true';
    var main = root.querySelector('.hgal__main');               // in-page scroll track
    var mainSlides = main ? main.querySelectorAll('.hgal__slide') : [];
    var thumbsEl = root.querySelector('.hgal__thumbs');
    var thumbBtns = root.querySelectorAll('.hgal__thumb');
    var gi = 0;
    var lb = null; // lightbox built lazily on first open

    function lbOpen() { return lb && lb.classList.contains('is-open'); }

    // keep the in-page thumbnails in sync with the current slide
    function syncThumbs() {
      thumbBtns.forEach(function (t, i) { t.classList.toggle('is-active', i === gi); });
      var at = thumbBtns[gi];
      if (thumbsEl && at) thumbsEl.scrollTo({ left: at.offsetLeft - (thumbsEl.clientWidth - at.clientWidth) / 2, behavior: 'smooth' });
    }
    // scroll the in-page main track to the current slide
    function setMain(smooth) { centreSlide(main, mainSlides[gi], smooth); }

    // ---- lightbox helpers ----
    function markActive() {
      if (!lb) return;
      lb.querySelectorAll('.hgal-lb__slide').forEach(function (s, i) { s.classList.toggle('is-on', i === gi); });
      var thumbs = lb.querySelectorAll('.hgal-lb__thumb');
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === gi); });
      var active = thumbs[gi], strip = lb.querySelector('.hgal-lb__thumbs');
      if (active && strip) strip.scrollTo({ left: active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2, behavior: 'smooth' });
    }
    function centerActive(smooth) {
      if (!lb) return;
      var vp = lb.querySelector('.hgal-lb__viewport');
      centreSlide(vp, vp.querySelector('.hgal-lb__slide[data-i="' + gi + '"]'), smooth);
    }
    // continuous neighbour dimming driven by live scroll position (desktop filmstrip; harmless on
    // mobile where one slide fills the screen). 1.0 at centre, fading to 0.13 a slide-width away.
    function dimLB(vp) {
      if (!vp) return;
      var c = vp.scrollLeft + vp.clientWidth / 2;
      vp.querySelectorAll('.hgal-lb__slide').forEach(function (s) {
        var dist = Math.abs(s.offsetLeft + s.clientWidth / 2 - c);
        var t = Math.max(0, 1 - dist / s.clientWidth);
        s.style.opacity = (0.13 + 0.87 * t).toFixed(3);
      });
    }

    // ---- navigation: when open the lightbox leads, otherwise the in-page track does ----
    function go(n) {
      gi = (gi + n + slides.length) % slides.length;
      if (lbOpen()) { markActive(); centerActive(); }
      else { setMain(true); syncThumbs(); }
    }
    function setIndex(i) {
      gi = i;
      if (lbOpen()) { markActive(); centerActive(); }
      else { setMain(true); syncThumbs(); }
    }

    function buildLB() {
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'hgal-lb';
        lb.innerHTML =
          // top bar (pill left, close right) — a real flex row above the image on mobile;
          // display:contents on desktop so the × + pill keep their absolute positions there
          '<div class="hgal-lb__topbar">' +
            (bestseller ? '<span class="hgal-lb__best">★ Our Best Seller</span>' : '') +
            '<button type="button" class="hgal-lb__x" aria-label="Close">×</button>' +
          '</div>' +
          '<button type="button" class="hgal-lb__nav hgal-lb__nav--prev" aria-label="Previous">‹</button>' +
          '<div class="hgal-lb__viewport"></div>' +
          '<button type="button" class="hgal-lb__nav hgal-lb__nav--next" aria-label="Next">›</button>' +
          // mobile-only thumb bar (hidden on desktop via CSS): ‹ scrollable thumbs ›
          '<div class="hgal-lb__thumbbar">' +
            '<button type="button" class="hgal-lb__tnav hgal-lb__tnav--prev" aria-label="Previous image">‹</button>' +
            '<div class="hgal-lb__thumbs">' +
              slides.map(function (s, i) {
                return '<button type="button" class="hgal-lb__thumb' + (i === gi ? ' is-active' : '') + '" data-i="' + i + '">' +
                       '<img class="hgal-lb__thumbimg" src="' + (s.thumb || s.mb) + '" alt="" loading="lazy" decoding="async"></button>';
              }).join('') +
            '</div>' +
            '<button type="button" class="hgal-lb__tnav hgal-lb__tnav--next" aria-label="Next image">›</button>' +
          '</div>';
        document.body.appendChild(lb);
        lb.querySelector('.hgal-lb__x').addEventListener('click', closeLB);
        // tap/click anywhere that isn't the image or a control (arrows/close) closes the zoom
        lb.addEventListener('click', function (e) {
          if (!e.target.closest('.hgal-lb__img, .hgal-lb__nav, .hgal-lb__x, .hgal-lb__thumb, .hgal-lb__tnav')) closeLB();
        });
        lb.querySelector('.hgal-lb__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
        lb.querySelector('.hgal-lb__nav--next').addEventListener('click', function (e) { e.stopPropagation(); go(1); });

        var vp = lb.querySelector('.hgal-lb__viewport');
        var settle, raf = false;
        vp.addEventListener('scroll', function () {
          // dim neighbours live, throttled to one rAF per frame
          if (!raf) { raf = true; requestAnimationFrame(function () { raf = false; dimLB(vp); }); }
          // settle on the centred slide once scrolling stops
          clearTimeout(settle);
          settle = setTimeout(function () {
            var best = centredIndex(vp, '.hgal-lb__slide');
            if (best !== gi) { gi = best; markActive(); syncThumbs(); centreSlide(main, mainSlides[gi], false); }
          }, 90);
        }, { passive: true });

        // lightbox thumb bar (mobile): tap a thumb to jump; arrows advance the image (strip follows via markActive)
        lb.querySelectorAll('.hgal-lb__thumb').forEach(function (btn) {
          btn.addEventListener('click', function (e) { e.stopPropagation(); setIndex(parseInt(btn.getAttribute('data-i'), 10) || 0); });
        });
        var lbtp = lb.querySelector('.hgal-lb__tnav--prev'), lbtn = lb.querySelector('.hgal-lb__tnav--next');
        if (lbtp) lbtp.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
        if (lbtn) lbtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
      }

      var dk = isDesktop();
      var vp2 = lb.querySelector('.hgal-lb__viewport');
      // Only the opened slide gets a real src (high priority) so it loads FIRST; the rest carry
      // their URL in data-src and are hydrated once the current image is in. (loading="lazy" is
      // unreliable here because the lightbox is display:none until is-open, so off-screen lazy
      // images can all fire at once when it's revealed — starving the one being viewed.)
      vp2.innerHTML = slides.map(function (s, i) {
        var src = dk ? (s.dt || s.mb) : (s.mb || s.dt);
        var alt = (s.alt || '').replace(/"/g, '&quot;');
        var cur = (i === gi);
        return '<div class="hgal-lb__slide' + (cur ? ' is-on' : '') + '" data-i="' + i + '">' +
               '<span class="hgal-lb__spinner" aria-hidden="true"></span>' +
               '<img class="hgal-lb__img" alt="' + alt + '" decoding="async" ' +
                 (cur ? 'src="' + src + '" fetchpriority="high"' : 'data-src="' + src + '"') + '></div>';
      }).join('');
      // hydrate = swap data-src -> src on the deferred slides (kick off their downloads)
      function hydrateRest() {
        vp2.querySelectorAll('.hgal-lb__img[data-src]').forEach(function (im) {
          im.src = im.getAttribute('data-src'); im.removeAttribute('data-src');
        });
      }
      vp2.querySelectorAll('.hgal-lb__slide').forEach(function (sl) {
        var im = sl.querySelector('.hgal-lb__img');
        // spinner clears + image fades in once it paints (immediately if cached); also clear on
        // error so a failed load doesn't spin forever
        if (im) {
          if (im.complete && im.naturalWidth) sl.classList.add('is-loaded');
          else {
            im.addEventListener('load', function () { sl.classList.add('is-loaded'); }, { once: true });
            im.addEventListener('error', function () { sl.classList.add('is-loaded'); }, { once: true });
          }
        }
        sl.addEventListener('click', function () {
          var i = parseInt(sl.getAttribute('data-i'), 10) || 0;
          if (i !== gi) setIndex(i);
        });
      });
      // once the opened image is in (or already cached), fill in the remaining slides
      var curImg = vp2.querySelector('.hgal-lb__slide[data-i="' + gi + '"] .hgal-lb__img');
      if (curImg && curImg.complete && curImg.naturalWidth) hydrateRest();
      else if (curImg) {
        curImg.addEventListener('load', hydrateRest, { once: true });
        curImg.addEventListener('error', hydrateRest, { once: true });
      }
    }

    function openLB() {
      buildLB();
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        centerActive(false);
        markActive();
        dimLB(lb.querySelector('.hgal-lb__viewport'));
      });
    }
    function closeLB() {
      if (!lb) return;
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      setMain(false); // land the in-page track on whatever slide the zoom finished on
    }

    // Prefetch the zoom-resolution asset for a slide on hover/touch intent, so the lightbox
    // image is already downloading (often cached) before the tap registers. Resolves the same
    // URL the lightbox will use (desktop -> dt||mb, mobile -> mb||dt) and dedupes per URL.
    var prefetched = {};
    function prefetchZoom(i) {
      var s = slides[i]; if (!s) return;
      var url = isDesktop() ? (s.dt || s.mb) : (s.mb || s.dt);
      if (!url || prefetched[url]) return;
      prefetched[url] = true;
      var im = new Image(); im.decoding = 'async'; im.src = url;
    }

    // ---- in-page main: scroll-driven index sync + tap-to-zoom ----
    if (main) {
      var settle2;
      main.addEventListener('scroll', function () {
        if (lbOpen()) return;
        clearTimeout(settle2);
        settle2 = setTimeout(function () {
          var best = centredIndex(main, '.hgal__slide');
          if (best !== gi) { gi = best; syncThumbs(); }
        }, 90);
      }, { passive: true });

      // desktop hover intent: warm the current slide's zoom asset before the click
      main.addEventListener('pointerenter', function () { prefetchZoom(gi); });

      // distinguish a tap (open zoom) from a drag/swipe (just scroll the track)
      var downX = 0, downY = 0, moved = false;
      main.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; moved = false; prefetchZoom(gi); });
      main.addEventListener('pointermove', function (e) {
        if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) moved = true;
      });
      main.addEventListener('click', function () { if (!moved) openLB(); });
      main.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLB(); }
      });
    }

    // magnifying-glass button: it lives on .hgal__mainwrap (outside the scroll track), so its
    // clicks never reach the in-page tap-to-zoom handler above — wire it to open the zoom too
    var zoomBtn = root.querySelector('.hgal__zoom');
    if (zoomBtn) {
      zoomBtn.addEventListener('pointerenter', function () { prefetchZoom(gi); });
      zoomBtn.addEventListener('click', function (e) { e.stopPropagation(); prefetchZoom(gi); openLB(); });
    }

    // in-page arrows + thumbnails
    var prev = root.querySelector('.hgal__nav--prev'), next = root.querySelector('.hgal__nav--next');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); go(1); });

    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { setIndex(parseInt(btn.getAttribute('data-i'), 10) || 0); });
    });

    var tprev = root.querySelector('.hgal__tnav--prev'), tnext = root.querySelector('.hgal__tnav--next');
    if (tprev) tprev.addEventListener('click', function () { go(-1); });
    if (tnext) tnext.addEventListener('click', function () { go(1); });

    // global keys while the lightbox is open
    document.addEventListener('keydown', function (e) {
      if (!lbOpen()) return;
      if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'Escape') closeLB();
    });

    syncThumbs();
  }

  function boot() { document.querySelectorAll('.hgal').forEach(initGallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
